import React from 'react';
import { SVGS } from '../../../assets/images';
import {FormattedMessage} from 'react-intl';
import styles from './create-new-button-v2.module.scss';

interface Props {
    onClick: () => void,
    disabled?: boolean,
}

export default function CreateNewButtonV2(props: Props) {
    return <button onClick={props.onClick} className={styles.createNewButtonV2} disabled={props.disabled}>
        <SVGS.PlusIcon />
        <div className={styles.buttonText}>
            <FormattedMessage id={'create_new'} />
        </div>
    </button>
}
